import { TransactionsBulkModals } from "./TransactionsBulkModals";
import { useTransactionBulkActions } from "./useTransactionBulkActions";

interface TransactionBulkModalsFromActionsProps {
    bulkActions: ReturnType<typeof useTransactionBulkActions>;
}

export const TransactionBulkModalsFromActions = ({
    bulkActions,
}: TransactionBulkModalsFromActionsProps) => (
    <TransactionsBulkModals
        shouldShowUnmatch={bulkActions.shouldShowUnmatch}
        closeUnmatch={() => bulkActions.setShouldShowUnmatch(false)}
        shouldShowUnsplit={bulkActions.shouldShowUnsplit}
        closeUnsplit={() => bulkActions.setShouldShowUnsplit(false)}
        shouldShowRevertGL={bulkActions.shouldShowRevertGL}
        closeRevertGL={() => bulkActions.setShouldShowRevertGL(false)}
        confirmRevertGL={bulkActions.confirmRevertGL}
        shouldShowRemoveCounterparty={bulkActions.shouldShowRemoveCounterparty}
        closeRemoveCounterparty={() =>
            bulkActions.setShouldShowRemoveCounterparty(false)
        }
        confirmRemoveCounterparty={bulkActions.confirmRemoveCounterparty}
        shouldShowRemoveCustomer={bulkActions.shouldShowRemoveCustomer}
        closeRemoveCustomer={() =>
            bulkActions.setShouldShowRemoveCustomer(false)
        }
        confirmRemoveCustomer={bulkActions.confirmRemoveCustomer}
        shouldShowDelete={bulkActions.shouldShowDelete}
        closeDelete={() => bulkActions.setShouldShowDelete(false)}
        confirmDelete={bulkActions.confirmDelete}
        shouldShowGusto={bulkActions.shouldShowGusto}
        closeGusto={() => bulkActions.setShouldShowGusto(false)}
        selectedArray={bulkActions.selectedArray}
        shouldShowCreateCounterparty={bulkActions.showCreateCounterparty}
        closeCreateCounterparty={() =>
            bulkActions.setShowCreateCounterparty(false)
        }
        onCreateCounterpartyClosed={bulkActions.handleCreateCounterpartyClosed}
        shouldShowCreateCustomer={bulkActions.showCreateCustomer}
        closeCreateCustomer={() => bulkActions.setShowCreateCustomer(false)}
        onCreateCustomerClosed={bulkActions.handleCreateCustomerClosed}
        shouldShowMemo={bulkActions.shouldShowMemo}
        closeMemo={() => bulkActions.setShouldShowMemo(false)}
        switchingToBusinessCategory={bulkActions.switchingToBusinessCategory}
        hideBusinessSelection={bulkActions.hideBusinessSelection}
        onBusinessSelected={bulkActions.onBusinessSelected}
        scheduleConfirmModal={bulkActions.scheduleConfirmModal}
    />
);
